import React from 'react';
import { Link } from 'react-router-dom';
import './ReportsHome.css';

const ReportsHome = () => {
  return (
    <div className="reports-home">
      <div className="reports-grid">
      
        <Link to="/reports/audit" className="report-card">
          <h3>Audit Report</h3>
          <p>View audit details.</p>
        </Link>

        <Link to="/reports/dcf" className="report-card">
          <h3>DCF Report</h3>
          <p>Export Document Control Form (DCF) data to Excel.</p>
        </Link>

        <Link to="/reports/action-item" className="report-card">
          <h3>Issue Report</h3>
          <p>Export Issue data to Excel.</p>
        </Link>

        <Link to="/reports/crf-data" className="report-card">
          <h3>Visit Report</h3>
          <p>Export Visit Report by Site and Visit.</p>
        </Link>
      </div>
    </div>
  );
};

export default ReportsHome;
